export default "__VITE_ASSET__24c4a9f0__"